import React from 'react';
import SuggestionListTable from './SuggestionListTable';

/**
 * FoodSuggestionsPage - Wrapper for food suggestions (isLabelFood=false)
 * Displays manually submitted food suggestions
 */
const FoodSuggestionsPage = () => {
  return (
    <SuggestionListTable
      type="food"
      title="Food Suggestions"
      description="Review and manage manually submitted food suggestions from users"
      basePath="/suggestions/foods"
    />
  );
};

export default FoodSuggestionsPage;
